import React from 'react';
import Panel from '../components/Panel';
import './ProfileEdit.scss';
import {FormGroup, Input, Label, Popover, PopoverBody} from 'reactstrap';
import auth from '../lib/auth';
import * as helpers from '../lib/helpers';
import * as api from '../lib/api';
import validate from '../lib/validator';

export default class ProfileEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      loading: false,
      changePassword: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      newPasswordErrors: [],
      passwordConfirmed: false,
      profile: {},
      profileChanged: false,
      uploading: false,
    };

    this.pictureFileRef = React.createRef();

    this.handleChangePasswordToggle = this.handleChangePasswordToggle.bind(
        this);
    this.save = this.save.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
  }

  async componentDidMount() {
    this.setState({
      initializing: false,
      profile: await auth.user(),
    });
  }

  async handlePictureChange(e) {
    let selectedPicture = e.target.files[0];
    if (!selectedPicture) return;

    this.setState({uploading: true});
    let result = await api.upload(selectedPicture);
    this.setState({
      uploading: false,
      profileChanged: true,
      profile: Object.assign({}, this.state.profile,
          {picture: result.Location}),
    });
  }

  handleProfileFieldChange(name, e) {

    this.setState({
      profileChanged: true,
      profile: Object.assign({}, this.state.profile,
          {[name]: e.target.value}),
    });

  }

  handleChangePasswordToggle(e) {
    let enabled = e.target.checked;
    let newState = {
      changePassword: enabled,
    };

    if (!enabled) {
      newState.oldPassword = '';
      newState.newPassword = '';
      newState.confirmPassword = '';
      newState.newPasswordErrors = [];
    }
    this.setState(newState);
    this.forceUpdate();
  }

  handlePasswordFieldChange(name, e) {
    let value = e.target.value;
    let newState = {
      [name]: value,
      profileChanged: true,
    };

    if (name === 'newPassword') {
      newState.newPasswordErrors = validate('password', value);
    }

    if (name === 'confirmPassword') {
      newState.passwordConfirmed = this.state.newPassword ===
          value;
    }

    this.setState(newState);
  }

  isPasswordValid() {
    return validate('password', this.state.newPassword) &&
        this.state.newPassword === this.state.confirmPassword && !!this.state.oldPassword;
  }

  save() {
    if (this.state.profileChanged) {
      if(this.state.changePassword && !this.isPasswordValid()){
        alert('Please check that your new password is valid and confirmed, and your old password supplied');
        return;
      }
      this.setState({loading: true});
      auth.update(this.state.profile, this.state.changePassword ? {
        oldPassword: this.state.oldPassword,
        newPassword: this.state.newPassword
      } : null).then(() => {
        window.location.reload();
      }).catch((err) => {
        alert(err.message);
        this.setState({loading: false});
      });
    }
  }

  renderChangePasswordFields() {
    return (
        <div className="row">
          <div className="container-fluid p-0">
            <div className="col-md-6">
              <div className="form-field">
                <label>Current:</label>
                <input className="field-wrap" placeholder="Current Password"
                       type="password" required="" tabIndex="7"
                       value={this.state.oldPassword || ''}
                       onChange={this.handlePasswordFieldChange.bind(this,
                           'oldPassword')}/>
              </div>
            </div>
          </div>
          <div className="container-fluid p-0">
            <div className="col-md-6">
              <div className="form-field">
                <label>New:</label>
                <input className="field-wrap" placeholder="New Password"
                       type="password" required="" tabIndex="8"
                       id="newPassword"
                       value={this.state.newPassword || ''}
                       onChange={this.handlePasswordFieldChange.bind(this,
                           'newPassword')}
                />

                <Popover isOpen={this.state.newPasswordErrors.length > 0 &&
                !!this.state.newPassword} target="newPassword">
                  <PopoverBody>
                    <ul>
                      {
                        this.state.newPasswordErrors.map((message, index) => {
                          return (
                              <li key={`error-message-${index}`}>{message}</li>);
                        })
                      }
                    </ul>
                  </PopoverBody>
                </Popover>
              </div>
            </div>
          </div>
          <div className="container-fluid p-0">
            <div className="col-md-6">
              <div className="form-field">
                <label>Verify:</label>
                <input className="field-wrap" placeholder="Verify Password"
                       type="password" required="" tabIndex="9"
                       id="confirmPassword"
                       value={this.state.confirmPassword || ''}
                       onChange={this.handlePasswordFieldChange.bind(this,
                           'confirmPassword')}/>
                <Popover isOpen={!!this.state.newPassword &&
                !this.state.passwordConfirmed}
                         target="confirmPassword">
                  <PopoverBody>
                    Must match the provided new password
                  </PopoverBody>
                </Popover>
              </div>
            </div>
          </div>
        </div>
    );
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : (
        <Panel title="Edit Profile" className="ProfileEdit">
          <div className="row">
            <div className="col-md-2">
              <div className="profile">
                <input type="file"
                       style={{display: 'none'}}
                       ref={this.pictureFileRef}
                       accept="image/x-png,image/png,image/jpeg,image/jpg"
                       onChange={this.handlePictureChange}
                />
                <button
                    className="profile-edit d-flex justify-content-center align-items-center"
                    disabled={this.state.uploading}
                >
                  {
                    this.state.uploading ?
                        (<i className="fa fa-spinner fa-spin"></i>) :
                        (<img src="/img/edit-icon.svg" alt="" onClick={() => {
                          this.pictureFileRef.current.click();
                        }} height={28} width={28}/>)
                  }

                </button>
                <img
                    className="profile-img"
                    src={this.state.profile.picture || '/img/profile.svg'}
                    alt=""
                />
                <span>Edit your photo</span>
              </div>
            </div>
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-field">
                    <label>First Name:</label>
                    <input className="field-wrap"
                           placeholder="John"
                           type="text"
                           required=""
                           tabIndex="1"
                           defaultValue={this.state.profile.nickname}
                           onChange={this.handleProfileFieldChange.bind(this,
                               'nickname')}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-field">
                    <label>Last Name:</label>
                    <input className="field-wrap" placeholder="Doe"
                           type="text" required="" tabIndex="2"
                           defaultValue={this.state.profile.family_name}
                           onChange={this.handleProfileFieldChange.bind(this,
                               'family_name')}/>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-field">
                    <label>Email:</label>
                    <input className="field-wrap"
                           placeholder="john@ancileo.com" type="email"
                           required="" tabIndex="3"
                           defaultValue={this.state.profile.email}
                           onChange={this.handleProfileFieldChange.bind(this,
                               'email')}/>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-field">
                    <label>Phone:</label>
                    <input className="field-wrap" placeholder="+6512345678"
                           type="text" required="" tabIndex="4"
                           defaultValue={this.state.profile.phone_number}
                           onChange={this.handleProfileFieldChange.bind(this,
                               'phone_number')}/>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-field">
                    <label>Designation:</label>
                    <input className="field-wrap"
                           placeholder="Software Engineer" type="text"
                           required="" tabIndex="5"
                           defaultValue={this.state.profile.profile}
                           onChange={this.handleProfileFieldChange.bind(this,
                               'profile')}/>
                  </div>
                </div>
              </div>
              <div className="row"
                   style={{marginTop: '20px', marginBottom: '20px'}}>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             tabIndex="6"
                             checked={this.state.changePassword}
                             onChange={this.handleChangePasswordToggle}
                      />{' '}
                      Change Password
                    </Label>
                  </FormGroup>
                </div>
              </div>
              {
                this.state.changePassword ?
                    this.renderChangePasswordFields() :
                    null
              }
            </div>
          </div>

          <div className="container-fluid clearfix p-0">
            <button className="btn btn-purple pull-right px-5"
                    disabled={this.state.loading || !this.state.profileChanged}
                    onClick={this.save}
            >
              Save
            </button>
          </div>
        </Panel>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/ProfileEdit.js